(ns ui.captions.style-picker
  "The style picker of the captions sidebar: every caption style as its
   own composition in a card, with the first words of the clip, paused
   on the first phrase and playing while the mouse is over it. A click
   picks the style (`:captions/set-style`)."
  (:require [app.captions.words :as words]
            [ui.captions.query :as query]
            [ui.captions.sample :as sample]
            [ui.captions.styles :as styles]
            [ui.hyperframes-templates.player :as player]))

(def preview-word-count
  8)

(def preview-at-seconds
  "Where a style preview stands still: inside the first phrase, while
   a word is active."
  0.9)

(defn preview-words
  "The first words of the clip, moved to the start, so every
   style preview shows the user's own text in its first phrase. The
   sample transcript stands in while the clip has no words."
  [clip]
  (let [clip-words (take preview-word-count
                         (words/clip-words (:asset/words (:clip/asset clip))
                                           (query/clip-range clip)))
        shift (- (or (:word/start (first clip-words)) 0) 100)]
    (if (seq clip-words)
      (map (fn [word]
             (-> word
                 (update :word/start - shift)
                 (update :word/end - shift)))
           clip-words)
      sample/words)))

(defn card-player
  "The player inside a style card: the card takes the clicks and the
   hover, so the player gets none. Nil while the player script has not
   defined the web component yet (`player/playable?`), a hover before
   that does nothing."
  [^js card]
  (let [player (.querySelector card "hyperframes-player")]
    (when (and player (player/playable? player))
      player)))

(defn play-preview!
  [^js event]
  (some-> (card-player (.-currentTarget event))
          (.play)
          (.catch (fn [_]))))

(defn pause-preview!
  [^js event]
  (when-let [player (card-player (.-currentTarget event))]
    (.pause player)
    (set! (.-currentTime player) preview-at-seconds)))

(defn style-card
  [{:keys [id name description]} current-id variables]
  (let [current? (= id current-id)]
    [:div {:replicant/key id
           :title description
           :class ["flex" "flex-col" "gap-1" "p-1" "rounded-lg" "cursor-pointer"
                   (if current? "bg-gray-700" "hover:bg-gray-700")]
           :on {:click [[:captions/set-style id]]
                :mouseenter play-preview!
                :mouseleave pause-preview!}}
     [:div {:class (cond-> ["rounded-md" "overflow-hidden" "bg-gray-900"]
                     current? (conj "ring-2" "ring-indigo-500"))
            :style {:aspect-ratio "9 / 16"}}
      (player/element {:id (str "captions-style-" id)
                       :template-id (str "captions/" id)
                       :variables variables
                       :width 1080
                       :height 1920
                       :paused-at preview-at-seconds
                       :style {:display "block"
                               :width "100%"
                               :height "100%"
                               :pointer-events "none"}})]
     [:span {:class ["text-xs" "text-center" (if current? "text-white" "text-slate-300")]}
      name]]))

(defn grid
  "Every style as its composition with the user's words, paused on the
   first phrase and playing while the mouse is over it."
  [clip current-id]
  (let [variables {"words" (words/composition-json (preview-words clip))}]
    (into [:div {:class ["grid" "grid-cols-2" "gap-2"]}]
          (map (fn [style]
                 (style-card style current-id variables))
               styles/styles))))
